/**
 * 判断数据不是空对象
 * @param obj
 * @returns {boolean}
 */
export function isNotEmptyObject(obj) {
  return (
    Object.prototype.toString.call(obj) === '[object Object]' &&
    Object.keys(obj).length > 0
  );
}

/**
 * 去除所字符串中有HTML标签
 * @param html 带有html的字符串
 * @returns {string}
 */
export function stripHtml(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  // let text = doc.body.textContent || '';
  //
  // // 核心修改：处理换行符和空白
  // text = text
  //   .replace(/(\r\n|\n|\r)+/g, '\n') // 合并连续换行符为单个
  //   .replace(/[^\S\n]+/g, ' ') // 合并非换行空白为单个空格
  //   .replace(/(\n\s*|\s*\n)/g, '\n') // 清理换行前后的空格
  //   .trim();
  //
  // return text;
  return doc.body.textContent || '';
}
